export const toTableRowItems = (items: SupportTraceability[]) =>
  items.map((item: SupportTraceability) => ({
    id: item.id,
    transportCode: item.transportCode || '',
    truckType: item.truckType || '',
    flowType: item.flowType || '',
    expeditionDate: item.expeditionDate || '',
    truckNumber: item.truckNumber || '',
    depositName: item.depositName || '',
    driverName: item.driverName || '',
    driverPhone: item.driverPhone || '',
    hubName: item.hubName || '',
    shopName: item.shopName || '',
    parentSociety: item.parentSociety || '',
    packageCategory: item.packageCategory || '',
    arrivedSupportsNumber: item.arrivedSupportsNumber || '',
    supportsNumberReleased: item.supportsNumberReleased || '',
    inHubReleaseDateTime: item.inHubReleaseDateTime || '',
    inHubPresentationHour: item.inHubPresentationHour || '',
    inHubReleaseHour: item.inHubReleaseHour || '',
    inHubLoadingDateTime: item.inHubLoadingDateTime || '',
    inHubLoadingHour: item.inHubLoadingHour || '',
    truckNumberHub: item.truckNumberHub || '',
    driverNameHub: item.driverNameHub || '',
    loadedSupportsNumber: item.loadedSupportsNumber || '',
    inShopReleaseDate: item.inShopReleaseDate || '',
    inShopReleaseHour: item.inShopReleaseHour || ''
  }))
